export const DatalligatorOperator = {
  afterDate: "afterDate",
  afterOrOnDate: "afterOrOnDate",
  beforeDate: "beforeDate",
  beforeOrOnDate: "beforeOrOnDate",
  contains: "contains",
  endsWith: "endsWith",
  equals: "equals",
  gt: "gt",
  gte: "gte",
  inDateRange: "inDateRange",
  lt: "lt",
  lte: "lte",
  notContains: "notContains",
  notEndsWith: "notEndsWith",
  notEquals: "notEquals",
  notInDateRange: "notInDateRange",
  notSet: "notSet",
  notStartsWith: "notStartsWith",
  set: "set",
  startsWith: "startsWith",
} as const;

export type DatalligatorOperator =
  (typeof DatalligatorOperator)[keyof typeof DatalligatorOperator];

export const OrderDirection = { asc: "asc", desc: "desc" } as const;

export type OrderDirection =
  (typeof OrderDirection)[keyof typeof OrderDirection];

export type DatalligatorFilter =
  | DatalligatorSingleFilter
  | DatalligatorCompositeFilter;

export type DatalligatorSingleFilter = {
  schema_field_name: string;
  operator: DatalligatorOperator;
  values: string[];
};

export type DatalligatorCompositeFilter = {
  boolean_logical_operator: "and" | "or";
  filters: (DatalligatorFilter | DatalligatorCompositeFilter)[];
};

export type DatalligatorOrder = {
  field_name: string;
  direction: OrderDirection;
};
